export default "__VITE_ASSET__Lckkp9no__"